import { Badge, Button, ButtonIcon, ShellIconPhone } from '@zrsystem/ui';
import type { ReactElement } from 'react';

import { useWorkspace } from '@/app/workspace/use-workspace.js';
import { useChatSidePanel } from '@/features/conversation/chat-side-panel-context.js';
import { useStaffConversations } from '@/features/conversation/hooks/use-staff-conversations.js';
import { useWhatsAppInboxSocket } from '@/features/notification/hooks/use-whatsapp-inbox-socket.js';
import { useWhatsAppInboxUnreadCount } from '@/features/notification/hooks/use-whatsapp-inbox-unread-count.js';
import '@/features/notification/whatsapp-inbox.css';

function sumStaffUnread(items: readonly { readonly unreadCount: number }[] | undefined): number {
  if (items === undefined) {
    return 0;
  }
  let total = 0;
  for (const item of items) {
    total += item.unreadCount;
  }
  return total;
}

export function WhatsAppInboxHeaderBadge(): ReactElement {
  const { activePlace } = useWorkspace();
  const { open, toggle } = useChatSidePanel();
  const placeId = activePlace?.id ?? '';
  const whatsAppUnread = useWhatsAppInboxUnreadCount();
  const staffQuery = useStaffConversations();
  const unreadCount = whatsAppUnread + sumStaffUnread(staffQuery.data?.items);

  useWhatsAppInboxSocket({
    enabled: placeId.length > 0,
    placeId,
  });

  const badgeLabel = unreadCount > 9 ? '9+' : String(unreadCount);

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      iconOnly
      className="whatsapp-inbox-header-badge"
      aria-label={unreadCount > 0 ? `Conversas, ${unreadCount} não lidas` : 'Abrir conversas'}
      aria-expanded={open}
      title="Conversas"
      onClick={toggle}
    >
      <ButtonIcon>
        <ShellIconPhone size={18} />
      </ButtonIcon>
      {unreadCount > 0 ? (
        <Badge variant="solid-primary" className="whatsapp-inbox-header-badge__count">
          {badgeLabel}
        </Badge>
      ) : null}
    </Button>
  );
}
